import React from 'react';

// Clickable <th> with an asc/desc arrow, driven by useSort's { sort, toggle }.
// `disabled` renders a plain header (no arrow, no click) — used when another
// ordering (e.g. trade grouping) owns the row order and sorting would mislead.
export function SortHeader({ field, sort, onSort, children, align = 'left', style, disabled = false }) {
  const active = sort.field === field;
  if (disabled) {
    return <th style={{ whiteSpace: 'nowrap', textAlign: align, ...style }}>{children}</th>;
  }
  return (
    <th
      onClick={() => onSort(field)}
      title="Sort"
      style={{ cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap', textAlign: align, ...style }}
    >
      {children}
      <span style={{ opacity: active ? 1 : 0.25 }}>{active ? (sort.dir === 'asc' ? ' ↑' : ' ↓') : ' ↕'}</span>
    </th>
  );
}

export default SortHeader;
